import { FuelTypography } from '@frete.com/fuel-react';

import * as Styled from './styled';

export const TermsOfUse = () => (
  <Styled.Content>
    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      Estes Termos e Condições de Uso (&quot;Termos de Uso&quot; ou &quot;Termos&quot;) regem o relacionamento entre
      você (&quot;Usuário&quot; ou &quot;Cliente&quot;) e a Fretebras Internet e Serviços Ltda., inscrita no CNPJ sob o
      nº 10.885.840/0001-32, com sede na Alameda Marmoré, nº 687, Alphaville Centro Industrial e Empresarial, 5º Andar,
      Conjunto 503, CEP: 06454-040, Cidade de Barueri, Estado de São Paulo (doravante denominada &quot;Fretebras&quot;),
      para fins de utilização do uso do produto GR Fretebras (&quot;GR Fretebras&quot;) disponível na Central do
      Assinante da Plataforma Fretebras (&quot;Plataforma&quot;), de propriedade exclusiva da Fretebras.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="bold" size="body-md">
      OBSERVE QUE, AO USAR OU ACESSAR NOSSOS SERVIÇOS, VOCÊ CONCORDA QUE LEU, COMPREENDEU E ACEITA ESTAR VINCULADO POR
      ESTES TERMOS.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="bold" size="body-md">
      Caso você não concorde com estes Termos de Uso da GR Fretebras, não deverá utilizar o produto e/ou acessar seu
      conteúdo.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      <FuelTypography displayInline color="inherit" weight="bold">
        Anexos
      </FuelTypography>
      : Formam parte integrante e inseparável destes Termos de Uso e a ele se integram por referência os seguintes
      documentos, os quais poderão ser consultados dentro da plataforma Fretebras: (i) Termos de Uso Fretebras e (ii)
      Política de Privacidade Fretebras, todas em conjunto denominadas (&quot;Políticas&quot;).
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      <FuelTypography displayInline color="inherit" weight="bold">
        Empresas Parceiras
      </FuelTypography>
      : São todas as gerenciadoras de risco parceiras da Fretebras.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      Qualquer divergência entre os Termos de Uso da GR Fretebras e as demais Políticas, prevalecerão as disposições
      constantes neste instrumento.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      Antes de utilizar a GR Fretebras, o Usuário/Cliente afirma ter lido, entendido e aceitado todas as condições
      estabelecidas nas Políticas.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="h2" weight="bold" size="body-lg">
      1. A GR Fretebras
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      1.1. A Fretebras é uma empresa de tecnologia proprietária da plataforma online Fretebras, que oferece espaço
      virtual por meio de licença de uso de software para que seus usuários, por conta própria, ofereçam e contratem
      diretamente serviços de transporte e logística, bem como outras soluções tecnológicas disponíveis na plataforma.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      1.2. A GR Fretebras é uma solução tecnológica integrada de gerenciamento de risco, oferecida pela Fretebras por
      meio de parcerias com empresas degerenciamento de riscos atuantes no mercado, e que permite ao cliente realizar
      consultas ou cadastros sobre o perfil securitário de empregados, prestadores de serviço de transporte de carga
      e/ou autônomos, direta ou indiretamente, e veículos ligados à sua operação.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      1.3. A Fretebras, portanto, limita-se a licenciar o direito de uso da Plataforma e da solução tecnológica de
      gerenciamento de risco, não interferindo, controlando e verificando, sob qualquer forma, as informações e dados
      inseridos na Plataforma pelos usuários e/ou clientes, bem como a interação, negociações e relações entre Usuários
      eventualmente surgidas em razão do uso e/ou contato por meio da Plataforma.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      1.4. Os Clientes que concordarem com estes Termos de Uso terão o direito de uso da funcionalidade GR Fretebras,
      que poderá ser acessada dentro da Central de Assinantes da Plataforma Fretebras.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      1.5. A solução tecnológica GR Fretebras fornece, por meio de integrações com plataformas de gerenciamento de risco
      de empresas parceiras, uma avaliação da compatibilidade de risco entre Caminhoneiro/Veículo e carga de um
      determinado frete que o Cliente pretende realizar. Para tanto, a Fretebras utiliza, sempre respeitando a
      legislação aplicável e nos moldes descritos em suas Políticas, os dados coletados para que sejam consultados nas
      plataformas de gerenciamento de risco de empresas parceiras, gerando um relatório com a informação do perfil
      securitário, baseada em fatores de risco e ajudando a complementar a tomada de decisão dos Clientes no tocante à
      utilização de determinados Motoristas e/ou Veículos para os fretes que pretendem realizar.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      1.6. Ciente da disposição acima, o Cliente entende e concorda que os serviços da GR Fretebras auxiliam na redução
      de vulnerabilidade e no aumento de segurança da Carga e do Motorista, mas NÃO GARANTE OU SE COMPROMETE COM A NÃO
      OCORRÊNCIA DE SINISTROS. Se você tiver alguma dúvida sobre estes Termos e Condições de Uso da Fretebras e da GR
      Fretebras, sinta-se à vontade para entrar em contato conosco.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      1.7. Os Usuários poderão acessar os Serviços GR Fretebras por meio da central de assinantes da Fretebras, dessa
      maneira, conseguirão fazer consultas ou cadastros por meio da Plataforma, facilitando o processo de tomada de
      decisão. O histórico de consultas e cadastros ficará disponível aos Clientes que se mantiverem ativos no uso dessa
      funcionalidade.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="h2" weight="bold" size="body-lg">
      2. USO E FUNCIONAMENTO DA GR FRETEBRAS
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      2.1. Ao acessar a GR Fretebras, disponível na Central de Assinantes da Plataforma, o Cliente deverá fazer uma
      solicitação de consulta ou cadastro e cadastrar as informações relacionadas ao frete, como dados do motorista e da
      Carteira Nacional de Habilitação - CNH, do veículo e proprietário, e dados da carga (mercadoria, valor, origem e
      destino). O tratamento desses dados pessoais será realizado nos termos previstos na Política de Privacidade da
      Fretebras.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      2.2. Para que a consulta ou cadastro sejam realizadas, é necessário que o motorista possua um cadastro regular
      (validado por biometria facial) na Fretebras. Caso o motorista não seja cadastrado na Fretebras, ele terá o prazo
      de até 24 (vinte e quatro) horas para tanto e, após esse período, a solicitação de consulta ou cadastro será
      cancelada automaticamente. Ainda, o Cliente é o único responsável pelo correto preenchimento dos dados requeridos.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      2.3. O Cliente é o único responsável por verificar em sua(s) apólice(s) de seguros se a gerenciadora de risco que
      fará a consulta ou cadastro na Plataforma é homologada pela seguradora.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      2.4. Após o preenchimento e envio de todos os dados, a GR Fretebras verificará, nas bases de dados da gerenciadora
      de risco parceira, se existe um cadastro válido para aquela solicitação. Nos casos em que houver um cadastro
      válido, a solicitação será contabilizada como consulta. Caso não haja um cadastro válido, a solicitação será
      contabilizada como um novo cadastro.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md" displayInline>
      <FuelTypography displayInline color="inherit">
        2.5. Uma vez inseridos os dados corretamente e concluída a sua análise, a GR Fretebras exibirá um relatório
        informando se há um perfil securitário para o frete, de acordo com a análise de risco.{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        Os relatórios solicitados ficarão disponíveis apenas para o Usuário, sendo vedada a exibição dos mesmos a
        terceiros, sob pena de responsabilização civil e criminal do Cliente e do funcionário infrator.
      </FuelTypography>
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      2.6. A contratação ou não do profissional consultado é uma decisão exclusiva do Usuário/Cliente que solicitou a
      consulta/cadastro, NÃO CABENDO A IMPUTAÇÃO DE QUALQUER RESPONSABILIDADE à Fretebras sobre essa decisão.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="h2" weight="bold" size="body-lg">
      3. PREÇOS E COBRANÇA
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.1. Os Usuários serão cobrados por Consultas ou Cadastros apenas quando retornarem com resultado positivo, ou
      seja, aprovado para embarque. Sendo assim, não serão cobrados por Consultas ou Cadastros com resultado não
      aprovado para embarque.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.2. Os preços e descontos poderão variar de acordo com os planos de assinatura dos Usuários, e podem ser
      consultados no site da Fretebras (www.fretebras.com.br) e na área logada da Central de Assinantes.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.2.1.De tempos em tempos, a Fretebras poderá alterar os valores e estes poderão ser revisados periodicamente para
      adequação e contínuo melhoramento da Plataforma e da GR Fretebras. A Fretebras também poderá ajustar os valores
      anualmente, ou com a maior frequência permitida pela legislação vigente, de acordo com a inflação estabelecida
      pelo Índice IGPM/FGV, ou outro índice equivalente aplicável aos Serviços da Fretebras.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.2.2.Quaisquer alterações de preço na GR Fretebras, serão aplicadas somente após o envio de notificação ao
      Usuário com antecedência. A utilização da GR Fretebras após as mudanças, importa imediata aceitação das
      alterações.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.3. A Fretebras poderá, a seu exclusivo critério, disponibilizar ao Usuário um período ou números de
      Consultas/Cadastros gratuitos para testes (&quot;Degustação&quot;).
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.3.1. A concessão do período de Degustação não implica em direito adquirido do Usuário. Dessa forma, após o
      período de Degustação, a Fretebras efetuará as cobranças devidas, de acordo com os valores estipulados.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.3.2. Ao optar por continuar usando a Plataforma e os Serviços após o fim do período de Degustação, o Usuário
      está ciente e de acordo com as cobranças dos valores decorrentes do uso.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.4. A Fretebras, desde já, reserva-se ao direito de disponibilizar ofertas e Serviços promocionais a determinados
      Usuários (&quot;Ofertas&quot;) a seu exclusivo critério, podendo revogá-las a qualquer momento. A Fretebras poderá
      usar os dados cadastrais do Usuário para determinar a elegibilidade de uma oferta.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.5. Para fins de cobrança, a Fretebras contabilizará o número de cadastros e Consultas solicitadas pelo Usuário
      em um determinado mês, emitirá um relatório com o volume daquele mês e cobrará o valor total na fatura do mês
      subsequente.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      3.6. Na hipótese de atraso ou falta de pagamento pelo Usuário, a Fretebras poderá bloquear o Usuário de maneira
      temporária ou definitiva, conforme previsto nos Termos de Uso da Fretebras.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="h2" weight="bold" size="body-lg">
      4. RESPONSABILIDADES
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      <FuelTypography displayInline color="inherit">
        4.1. O Cliente concorda, desde já, que a Fretebras, ao oferecer o produto GR Fretebras, atua única e
        exclusivamente como{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        intermediadora{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit">
        de consultas e cadastros com empresas de gerenciamento de riscos que têm por finalidade, mediante cadastro em
        bancos de dados públicos lícitos/legais, fornecer a avaliação de compatibilidade de riscos entre o motorista e a
        carga pretendida, a partir de dados fornecidos pelo Cliente, sendo certo que{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        NÃO SE TRATA DE EMPRESA SEGURADORA e o Serviço não se confunde com qualquer outro tipo de serviço securitário.
      </FuelTypography>
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      <FuelTypography displayInline color="inherit">
        4.2. O Cliente concorda, desde já, que as consultas são realizadas somente mediante solicitação do Cliente,
        sendo que o parecer fornecido pela GR Fretebras, a partir dos cadastros realizados, tem o intuito de mitigar
        riscos na contratação do motorista que o Cliente deseja contratar. A GR Fretebras{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        NÃO GARANTE A NÃO OCORRÊNCIA DE QUALQUER SINISTRO E/OU PREJUÍZO.
      </FuelTypography>
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      <FuelTypography displayInline color="inherit">
        O Cliente concorda, desde já, que{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        está ciente que existem outras formas de precauções comuns ao ramo de atividade em que atua
      </FuelTypography>
      <FuelTypography displayInline color="inherit">
        , como, por exemplo: (i) se assegurar que o motorista que vai realizar o embarque da carga é o mesmo cujas
        informações foram fornecidas na solicitação e que ele porta o mesmo documento que foi informado, (ii) avaliar se
        é a primeira viagem do motorista para o Cliente; (iii) buscar referências profissionais sobre o motorista com o
        perfil consultado e (iv) avaliar e garantir caso o plano de gerenciamento de riscos acordado com a seguradora
        e/ou cliente necessite de outras medidas de segurança como: monitoramento, rastreamento, iscas, etc.{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        Dessa forma, a decisão final de contratar ou não os serviços e suas consequências é uma decisão integralmente do
        Cliente.
      </FuelTypography>
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      <FuelTypography displayInline color="inherit">
        4.4. Assim,{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        É RESPONSABILIDADE INTEGRAL DO CLIENTE, TODO ATO POSTERIOR À CONSULTA REALIZADA. A FRETEBRAS NÃO INTERFERE,
        PARTICIPA OU SE RESPONSABILIZA EM NENHUMA HIPÓTESE PELA RELAÇÃO COMERCIAL DO CLIENTE E/OU MOTORISTA COM O PERFIL
        CONSULTADO.
      </FuelTypography>
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      <FuelTypography displayInline color="inherit">
        4.5.{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        A FRETEBRAS NÃO GARANTE A EXATIDÃO DAS INFORMAÇÕES OBTIDAS, VISTO QUE SÃO OBTIDAS PELAS GERENCIADORAS DE RISCO
        PARCEIRAS EM FONTES PÚBLICAS QUE PODEM OU NÃO ESTAR ATUALIZADAS.
      </FuelTypography>
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      <FuelTypography displayInline color="inherit">
        4.6. O Cliente concorda que é o detentor dos dados de contato do Motorista e/ou Perfil Consultado, uma vez que a
        GR Fretebras apenas consulta empresas gerenciadoras de risco parceiras que realizam cadastros e confirmam
        dadosutilizando as fontes públicas. Em razão disso,{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        É RESPONSABILIDADE DO CLIENTE ENTRAR EM CONTATO COM A GERENCIADORA DE RISCO PARCEIRA CASO QUEIRA OBTER MAIS
        INFORMAÇÕES SOBRE A AVALIAÇÃO DO PERFIL CONSULTADO.
      </FuelTypography>
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="h2" weight="bold" size="body-lg">
      5. SEGURANÇA VIRTUAL
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      5.1. O Usuário não deve fazer uso indevido da Plataforma permitindo a introdução consciente de vírus,
      &quot;cookies&quot; ou qualquer outro artifício malicioso ou tecnologicamente prejudicial (em conjunto,
      &quot;Vírus&quot;). O Usuário não deve tentar obter acesso não autorizado a nosso site, nossos servidores ou
      qualquer servidor, computador, ou base de dados relacionada a este produto. O usuário não deve fazer uso de
      técnicas e ferramentas de automação para a interação, inserção ou obtenção de dados com o site, exceto em casos
      autorizados integração com plataformas de sistema de gestão de fretes (TMS ou Transportation Management Systems).
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      5.2. A Plataforma somente poderá ser veiculada por meio de links mediante a prévia autorização por escrito da
      Fretebras.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="h2" weight="bold" size="body-lg">
      6. POLÍTICA DE PRIVACIDADE
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      6.1. A Fretebras respeita sua privacidade e proteção dos dados pessoais, de modo que observará os melhores padrões
      de segurança da informação, bem como utilizará e armazenará os dados dos caminhoneiros autônomos ou qualquer outro
      dado pessoal a que tenha acesso, constantes em seus sistemas, em respeito à legislação vigente, reconhecendo e
      comprometendo-se a cumprir com a Lei Geral de Proteção de Dados Pessoais (Lei 13.709/2018), quando aplicável. Para
      mais detalhes, favor verificar a Política de Privacidade da Fretebras.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="h2" weight="bold" size="body-lg">
      7. DISPOSIÇÕES GERAIS
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      7.1. Qualquer uso da Plataforma pelo Usuário após a data de vigência da alteração dos Termos e Condições de Uso
      constituirá na plena e irrestrita aceitação das modificações realizadas. Caso o Usuário não concorde com as
      modificações e atualizações, deverá cessar toda e qualquer utilização da Plataforma.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      7.2. Endereço para envio de correspondências: Todas as requisições, correspondências, notificações ou pedidos de
      informação deverão ser enviadas para o endereço da filial da Fretebras, sob pena de invalidade do ato - Rua Gomes
      de Carvalho, nº 1.195, Térreo, Vila Olímpia, Cidade de São Paulo, Estado de São Paulo, CEP 04547 004, Cidade de
      São Paulo, Estado de São Paulo.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      7.3. Modificações: A Fretebras poderá modificar os Termos de Uso da GR Fretebras a qualquer momento, comunicando
      as modificações no site e/ou aplicativo. Por sua vez, a Fretebras se reserva o direito de descontinuar, terminar,
      cancelar, suspender temporária ou definitivamente o oferecimento do produto GR Fretebras.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      <FuelTypography displayInline color="inherit">
        7.4.{' '}
      </FuelTypography>
      <FuelTypography displayInline color="inherit" weight="bold">
        Canais de Atendimento
      </FuelTypography>
      <FuelTypography displayInline color="inherit">
        : o Cliente e/ou Usuário poderá entrar em contato com a Fretebras para informações, dúvidas ou problemas sobre
        os serviços da GR Fretebras - Email: atendimento.empresas@fretebras.com.br.
      </FuelTypography>
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="h2" weight="bold" size="body-lg">
      8. LEGISLAÇÃO E FORO
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      8.1. Estes Termos de Uso serão regidos pelas leis vigentes na República Federativa do Brasil.
    </FuelTypography>

    <FuelTypography color="neutral-default" tag="p" weight="medium" size="body-md">
      8.2. Eventuais disputas provenientes do presente Termo, deverão ser submetidas ao foro da Comarca de São Paulo,
      Estado de São Paulo.
    </FuelTypography>
  </Styled.Content>
);
